import { render, staticRenderFns } from "./Indications.vue?vue&type=template&id=3452700a"
import script from "./Indications.vue?vue&type=script&lang=js"
export * from "./Indications.vue?vue&type=script&lang=js"
import style0 from "./Indications.vue?vue&type=style&index=0&id=3452700a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports